<template>
  <div v-if="editor" class="container" :class="{ 'is-fullscreen': isFullscreen }">
    <div class="control-group">
      <!--   Hoàn tác / Làm lại (Undo / Redo)   -->
      <div class="button_group">
        <el-tooltip content="Hoàn tác (Undo)" placement="top" :open-delay="500">
          <div
              @click="editor.chain().focus().undo().run()"
              class="button_control"
          >
            <i class="el-icon-refresh-left" style="font-size: 16px; color: #475569;" />
          </div>
        </el-tooltip>
        <el-tooltip content="Làm lại (Redo)" placement="top" :open-delay="500">
          <div
              @click="editor.chain().focus().redo().run()"
              class="button_control"
          >
            <i class="el-icon-refresh-right" style="font-size: 16px; color: #475569;" />
          </div>
        </el-tooltip>
      </div>

      <!--   Chọn tiêu đề (heading) và font chữ   -->
      <div class="button_group">
        <el-tooltip content="Chọn kiểu tiêu đề" placement="top" :open-delay="500">
          <div class="button_control-select" style="width: 105px;">
            <el-select v-model="controlHeading.selectedHeading" @change="updateHeading" size="mini" style="width: 100%;">
              <el-option v-for="item in controlHeading.countOption" :key="item" :value="item+2"
                         :label="'Heading ' + item"></el-option>
              <el-option :value="null" label="Mặc định"></el-option>
            </el-select>
          </div>
        </el-tooltip>

        <el-tooltip content="Chọn phông chữ" placement="top" :open-delay="500">
          <div class="button_control-select" style="width: 110px;">
            <el-select v-model="controlFontFamily.selectedFontFamily" size="mini" style="width: 100%;">
              <el-option v-for="(item, index) in controlFontFamily.optionsFontFamily" :key="index" :value="item.value"
                         :label="item.label"></el-option>
            </el-select>
          </div>
        </el-tooltip>

        <el-tooltip content="Chọn cỡ chữ" placement="top" :open-delay="500">
          <div class="button_control-select" style="width: 85px;">
            <el-select v-model="selectedFontSize" @change="updateFontSize" size="mini" placeholder="Cỡ chữ" style="width: 100%;">
              <el-option v-for="size in fontSizes" :key="size" :value="size" :label="size"></el-option>
            </el-select>
          </div>
        </el-tooltip>

        <el-tooltip content="Khoảng cách dòng" placement="top" :open-delay="500">
          <div class="button_control-select" style="width: 80px;">
            <el-select v-model="selectedLineHeight" @change="updateLineHeight" size="mini" placeholder="Dòng" style="width: 100%;">
              <el-option value="normal" label="Mặc định"></el-option>
              <el-option value="1.15" label="1.15"></el-option>
              <el-option value="1.3" label="1.3"></el-option>
              <el-option value="1.5" label="1.5"></el-option>
              <el-option value="1.8" label="1.8"></el-option>
              <el-option value="2.0" label="2.0"></el-option>
            </el-select>
          </div>
        </el-tooltip>
      </div>

      <!--   chọn kiểu dáng chữ (đậm, nghiêng, gạch chân, gạch ngang, xóa định dạng)   -->
      <div class="button_group">
        <el-tooltip content="In đậm" placement="top" :open-delay="500">
          <div
              @click="editor.chain().focus().toggleBold().run()"
              :class="{
                'is-active': editor.isActive('bold'),
                'button_control': true
              }"
          >
            <el-image :src="icon.bold"/>
          </div>
        </el-tooltip>

        <el-tooltip content="In nghiêng" placement="top" :open-delay="500">
          <div
              @click.prevent="editor.chain().focus().toggleItalic().run()"
              :class="{
                'is-active': editor.isActive('italic'),
                'button_control': true
              }"
          >
            <el-image :src="icon.italic"/>
          </div>
        </el-tooltip>

        <el-tooltip content="Gạch chân" placement="top" :open-delay="500">
          <div
              @click="editor.chain().focus().toggleUnderline().run()"
              :class="{
                'is-active': editor.isActive('underline'),
                'button_control': true
              }"
          >
            <el-image :src="icon.underline"/>
          </div>
        </el-tooltip>

        <el-tooltip content="Gạch ngang chữ" placement="top" :open-delay="500">
          <div
              @click.prevent="editor.chain().focus().toggleStrike().run()"
              :class="{
                'is-active': editor.isActive('strike'),
                'button_control': true
              }"
          >
            <el-image :src="icon.strikethrough"/>
          </div>
        </el-tooltip>

        <el-tooltip content="Xóa toàn bộ định dạng" placement="top" :open-delay="500">
          <div
              @click="editor.chain().focus().clearNodes().unsetAllMarks().run()"
              class="button_control"
          >
            <i class="el-icon-magic-stick" style="font-size: 16px; color: #475569;" />
          </div>
        </el-tooltip>
      </div>

      <!--   màu chữ và highlight đoạn   -->
      <div class="button_group">
        <el-tooltip content="Màu chữ" placement="top" :open-delay="500">
          <el-popover
              class="button_control"
              placement="bottom"
              width="100"
              v-model="popoverControl.color">
            <div>
              <el-row>
                <el-col :span="4" v-for="(item, index) in colorText()" :key="index">
                  <div class="container_item" @click="addColorText(item)"
                       :class="{ 'is-active_color': color.text === item }">
                    <div class="option_color" :style="{backgroundColor: item}"></div>
                  </div>
                </el-col>
              </el-row>
            </div>

            <template #reference>
              <div class="button_control style_text">
                <div style="display: flex; justify-content: center; align-items: center; line-height: normal">
                  <el-image :src="icon.text_a"/>
                </div>

                <div :style="{
              height: '10px',
              width: '100%',
              border: `1px solid ${color.text}`
            }"></div>
              </div>
            </template>
          </el-popover>
        </el-tooltip>

        <el-tooltip content="Màu nền chữ (Highlight)" placement="top" :open-delay="500">
          <el-popover
              class="button_control"
              placement="bottom"
              width="160"
              v-model="popoverControl.background">
            <div>
              <el-row>
                <el-col :span="4" v-for="(item, index) in colorText()" :key="index">
                  <div class="container_item" @click="addColorBackground(item)"
                       :class="{ 'is-active_color': color.background === item }">
                    <div class="option_color" :style="{backgroundColor: item}"></div>
                  </div>
                </el-col>

                <el-col :span="4">
                  <div class="container_item" @click="addColorBackground(false)">
                    <div class="option_color"
                         style="background-color: #fff; display: flex; justify-content: center; align-items: center">
                      x
                    </div>
                  </div>
                </el-col>
              </el-row>
            </div>

            <template #reference>
              <div class="button_control style_text">
                <div style="display: flex; justify-content: center; align-items: center; line-height: normal">
                  <el-image :src="icon.pen_line"/>
                </div>

                <div :style="{
              height: '10px',
              width: '100%',
              border: `1px solid ${color.background}`
            }"></div>
              </div>
            </template>
          </el-popover>
        </el-tooltip>
      </div>

      <!--   Chỉ số dưới / Chỉ số trên   -->
      <div class="button_group">
        <el-tooltip content="Chỉ số dưới (Subscript)" placement="top" :open-delay="500">
          <div
              @click.prevent="editor.chain().focus().toggleSubscript().run()"
              :class="{
                'is-active': editor.isActive('subscript'),
                'button_control': true
              }"
          >
            <el-image :src="icon.subscript"/>
          </div>
        </el-tooltip>

        <el-tooltip content="Chỉ số trên (Superscript)" placement="top" :open-delay="500">
          <div
              @click.prevent="editor.chain().focus().toggleSuperscript().run()"
              :class="{
                'is-active': editor.isActive('superscript'),
                'button_control': true
              }"
          >
            <el-image :src="icon.superscript"/>
          </div>
        </el-tooltip>
      </div>

      <!--   Xuống dòng / Đường kẻ phân cách   -->
      <div class="button_group">
        <el-tooltip content="Xuống dòng (Shift + Enter)" placement="top" :open-delay="500">
          <div
              @click.prevent="editor.chain().focus().setHardBreak().run()"
              :class="{
                'button_control': true
              }"
          >
            <el-image :src="icon.break"/>
          </div>
        </el-tooltip>

        <el-tooltip content="Đường kẻ ngang phân cách" placement="top" :open-delay="500">
          <div
              @click.prevent="editor.chain().focus().setHorizontalRule().run()"
              :class="{
                'button_control': true
              }"
          >
            <el-image :src="icon.line"/>
          </div>
        </el-tooltip>
      </div>

      <!--   Trích dẫn và Khối mã (Blockquote & Code block)   -->
      <div class="button_group">
        <el-tooltip content="Khối trích dẫn (Blockquote)" placement="top" :open-delay="500">
          <div
              @click.prevent="editor.chain().focus().toggleBlockquote().run()"
              :class="{
                'is-active': editor.isActive('blockquote'),
                'button_control': true
              }"
          >
            <i class="el-icon-chat-square" style="font-size: 16px; color: #475569;" />
          </div>
        </el-tooltip>

        <el-tooltip content="Khối mã nguồn (Code block)" placement="top" :open-delay="500">
          <div
              @click.prevent="editor.chain().focus().toggleCodeBlock().run()"
              :class="{
                'is-active': editor.isActive('codeBlock'),
                'button_control': true
              }"
          >
            <i class="el-icon-cpu" style="font-size: 16px; color: #475569;" />
          </div>
        </el-tooltip>
      </div>

      <!--   Chèn Emoji   -->
      <div class="button_group">
        <el-tooltip content="Chèn biểu tượng cảm xúc (Emoji)" placement="top" :open-delay="500">
          <el-popover
              placement="bottom"
              width="250"
              trigger="click"
              v-model="popoverControl.emoji"
          >
            <div class="emoji-picker">
              <span
                  v-for="item in commonEmojis"
                  :key="item"
                  @click="insertEmoji(item)"
                  class="emoji-item"
              >
                {{ item }}
              </span>
            </div>
            <template #reference>
              <div class="button_control" style="display: flex; align-items: center; justify-content: center;">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="#475569" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <circle cx="12" cy="12" r="10" />
                  <path d="M8 14s1.5 2 4 2 4-2 4-2" />
                  <line x1="9" y1="9" x2="9.01" y2="9" />
                  <line x1="15" y1="9" x2="15.01" y2="9" />
                </svg>
              </div>
            </template>
          </el-popover>
        </el-tooltip>
      </div>

      <!--   Bảng biểu (Table)   -->
      <div class="button_group">
        <el-tooltip content="Quản lý bảng biểu" placement="top" :open-delay="500">
          <el-popover
              placement="bottom"
              width="200"
              trigger="click"
              v-model="popoverControl.table"
          >
            <div class="table-menu">
              <!-- Cấu hình chèn bảng mới bằng Grid di chuột 8x8 cực đẹp -->
              <div v-if="!editor.isActive('table')" class="table-insert-grid">
                <div style="font-weight: 500; font-size: 13px; margin-bottom: 8px; color: #1e293b; text-align: center;">
                  Chèn bảng: {{ gridHover.rows || 0 }} x {{ gridHover.cols || 0 }}
                </div>
                <div class="grid-container" @mouseleave="resetGridHover">
                  <div
                      v-for="r in 8"
                      :key="'r-' + r"
                      class="grid-row"
                  >
                    <div
                        v-for="c in 8"
                        :key="'c-' + c"
                        class="grid-cell"
                        :class="{
                          'is-selected': r <= gridHover.rows && c <= gridHover.cols
                        }"
                        @mouseover="onGridHover(r, c)"
                        @click="createTableFromGrid(r, c)"
                    ></div>
                  </div>
                </div>
              </div>

              <!-- Menu quản lý bảng khi đã có bảng -->
              <template v-else>
                <div @click="execTableCmd('addColumnBefore')" class="table-menu-item">
                  <i class="el-icon-back" /> Thêm cột trước
                </div>
                <div @click="execTableCmd('addColumnAfter')" class="table-menu-item">
                  <i class="el-icon-right" /> Thêm cột sau
                </div>
                <div @click="execTableCmd('deleteColumn')" class="table-menu-item">
                  <i class="el-icon-close" style="color: #ef4444;" /> Xóa cột
                </div>
                <div class="table-menu-divider"></div>
                <div @click="execTableCmd('addRowBefore')" class="table-menu-item">
                  <i class="el-icon-top" /> Thêm dòng trên
                </div>
                <div @click="execTableCmd('addRowAfter')" class="table-menu-item">
                  <i class="el-icon-bottom" /> Thêm dòng dưới
                </div>
                <div @click="execTableCmd('deleteRow')" class="table-menu-item">
                  <i class="el-icon-close" style="color: #ef4444;" /> Xóa dòng
                </div>
                <div class="table-menu-divider"></div>
                <div @click="execTableCmd('mergeOrSplit')" class="table-menu-item">
                  <i class="el-icon-copy-document" /> Gộp / Tách ô
                </div>
                <div @click="execTableCmd('deleteTable')" class="table-menu-item" style="color: #ef4444;">
                  <i class="el-icon-delete" style="color: #ef4444;" /> Xóa bảng
                </div>
                <div class="table-menu-divider"></div>
                <div style="padding: 6px 8px 4px 8px;">
                  <div style="font-weight: 500; font-size: 11px; color: #64748b; margin-bottom: 6px;">Màu nền ô</div>
                  <div style="display: grid; grid-template-columns: repeat(5, 1fr); gap: 6px;">
                    <div
                        v-for="c in tableCellColors"
                        :key="c.value"
                        @click="setCellBgColor(c.value)"
                        :style="{ backgroundColor: c.value }"
                        style="width: 22px; height: 22px; border-radius: 4px; border: 1px solid #cbd5e1; cursor: pointer; display: flex; align-items: center; justify-content: center; box-sizing: border-box;"
                        :title="c.label"
                    >
                      <i v-if="c.value === 'transparent'" class="el-icon-close" style="font-size: 10px; color: #ef4444;" />
                    </div>
                  </div>
                </div>
              </template>
            </div>
            <template #reference>
              <div class="button_control" :class="{ 'is-active': editor.isActive('table') }" style="display: flex; align-items: center; justify-content: center;">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="#475569" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <rect x="3" y="3" width="18" height="18" rx="2" />
                  <line x1="3" y1="9" x2="21" y2="9" />
                  <line x1="3" y1="15" x2="21" y2="15" />
                  <line x1="9" y1="3" x2="9" y2="21" />
                  <line x1="15" y1="3" x2="15" y2="21" />
                </svg>
              </div>
            </template>
          </el-popover>
        </el-tooltip>
      </div>

      <!--   căn vị trí văn bản   -->
      <div class="button_group">
        <el-tooltip content="Danh sách dấu chấm (Bullet list)" placement="top" :open-delay="500">
          <div
              @click="editor.chain().focus().toggleBulletList().run()"
              :class="{
                'is-active': editor.isActive('bulletList'),
                'button_control': true
              }"
          >
            <el-image :src="icon.list_bulleted"/>
          </div>
        </el-tooltip>

        <el-tooltip content="Danh sách đánh số (Ordered list)" placement="top" :open-delay="500">
          <div
              @click="editor.chain().focus().toggleOrderedList().run()"
              :class="{
                'is-active': editor.isActive('orderedList'),
                 'button_control': true
              }"
          >
            <el-image :src="icon.list_number"/>
          </div>
        </el-tooltip>

        <div class="button_group-child">
          <el-tooltip content="Căn lề trái" placement="top" :open-delay="500">
            <div
                @click="editor.chain().focus().setTextAlign('left').run()"
                :class="{
                  'is-active': editor.isActive({ textAlign: 'left' }),
                  'button_control': true
                }"
            >
              <el-image :src="icon.justify_left"/>
            </div>
          </el-tooltip>

          <el-tooltip content="Căn giữa" placement="top" :open-delay="500">
            <div
                @click="editor.chain().focus().setTextAlign('center').run()"
                :class="{
                  'is-active': editor.isActive({ textAlign: 'center' }),
                  'button_control': true
                }"
            >
              <el-image :src="icon.justify_center"/>
            </div>
          </el-tooltip>

          <el-tooltip content="Căn lề phải" placement="top" :open-delay="500">
            <div
                @click="editor.chain().focus().setTextAlign('right').run()"
                :class="{
                  'is-active': editor.isActive({ textAlign: 'right' }),
                  'button_control': true
                }"
            >
              <el-image :src="icon.justify_right"/>
            </div>
          </el-tooltip>

          <el-tooltip content="Căn đều hai bên" placement="top" :open-delay="500">
            <div
                @click="editor.chain().focus().setTextAlign('justify').run()"
                :class="{
                  'is-active': editor.isActive({ textAlign: 'justify' }),
                  'button_control': true
                }"
            >
              <el-image :src="icon.justify"/>
            </div>
          </el-tooltip>
        </div>
      </div>

      <!--   công cụ link, ảnh   -->
      <div class="button_group">
        <el-tooltip content="Chèn liên kết" placement="top" :open-delay="500">
          <div
              @click="openLinkDialog"
              :class="{
                'is-active': editor && editor.isActive('link'),
                'button_control': true
              }"
          >
            <el-image :src="icon.link"/>
          </div>
        </el-tooltip>

        <el-tooltip content="Chèn hình ảnh" placement="top" :open-delay="500">
          <div
              @click="openImageDialog"
              :class="{
                'button_control': true
              }"
          >
            <el-image :src="icon.image"/>
          </div>
        </el-tooltip>
      </div>

      <!--   Tìm kiếm & Thay thế (Search & Replace)   -->
      <div class="button_group">
        <el-tooltip content="Tìm kiếm & Thay thế" placement="top" :open-delay="500">
          <div
              @click="toggleSearchReplace"
              :class="{
                'is-active': showSearchReplace,
                'button_control': true
              }"
              style="display: flex; align-items: center; justify-content: center;"
          >
            <i class="el-icon-search" style="font-size: 16px; color: #475569;" />
          </div>
        </el-tooltip>
      </div>

      <!--   Toàn màn hình (Fullscreen)   -->
      <div class="button_group">
        <el-tooltip :content="isFullscreen ? 'Thu nhỏ cửa sổ' : 'Phóng to toàn màn hình'" placement="top" :open-delay="500">
          <div
              @click="toggleFullscreen"
              :class="{
                'is-active': isFullscreen,
                'button_control': true
              }"
              style="display: flex; align-items: center; justify-content: center;"
          >
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="#475569" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M8 3H5a2 2 0 0 0-2 2v3m18 0V5a2 2 0 0 0-2-2h-3m0 18h3a2 2 0 0 0 2-2v-3M3 16v3a2 2 0 0 0 2 2h3" />
            </svg>
          </div>
        </el-tooltip>
      </div>
    </div>

    <!--   Thanh Tìm kiếm & Thay thế   -->
    <div v-if="showSearchReplace" class="search-replace-panel">
      <div class="search-replace-row">
        <el-input
            v-model="searchQuery"
            placeholder="Tìm kiếm từ..."
            size="mini"
            @input="onSearchInput"
            style="width: 160px;"
            clearable
        ></el-input>
        
        <div style="font-size: 13px; color: #64748b; min-width: 50px; text-align: center; font-weight: 500;">
          {{ searchStats.current }} / {{ searchStats.total }}
        </div>
        
        <el-button-group style="margin-right: 8px;">
          <el-button size="mini" icon="el-icon-arrow-left" @click="handlePrevMatch" :disabled="searchStats.total === 0" style="padding: 7px 10px;"></el-button>
          <el-button size="mini" icon="el-icon-arrow-right" @click="handleNextMatch" :disabled="searchStats.total === 0" style="padding: 7px 10px;"></el-button>
        </el-button-group>

        <el-input
            v-model="replaceQuery"
            placeholder="Thay thế bằng..."
            size="mini"
            style="width: 160px; margin-right: 8px;"
            clearable
        ></el-input>
        <el-button type="primary" size="mini" @click="handleReplace" :disabled="searchStats.total === 0">Thay thế</el-button>
        <el-button type="success" size="mini" @click="handleReplaceAll" :disabled="searchStats.total === 0">Thay thế tất cả</el-button>
        <el-button type="text" size="mini" @click="closeSearchReplace" style="color: #64748b; margin-left: auto;">
          <i class="el-icon-close" style="font-size: 16px;" />
        </el-button>
      </div>
    </div>

    <editor-content class="content" :editor="editor" :style="{ '--editor-height': height }"></editor-content>

    <!--   Footer hiển thị thống kê bộ đếm từ/ký tự   -->
    <div class="editor-footer">
      <span class="footer-stat">Số từ: <strong>{{ wordCount }}</strong></span>
      <span class="footer-stat-separator">|</span>
      <span class="footer-stat">Ký tự: <strong>{{ charCount }}</strong></span>
    </div>

    <!-- Dialog Chèn / Sửa Liên Kết hiện đại -->
    <DialogBase
      :visible="dialogLinkVisible"
      :append-to-body="true"
      title="Chèn liên kết"
      width="480px"
      top="15vh"
      panel-icon="el-icon-link"
      panel-title="Cấu hình liên kết"
      panel-subtitle="Nhập đường dẫn trang web và văn bản hiển thị"
      :show-confirm="!linkForm.isEditing"
      confirm-text="Chèn liên kết"
      confirm-icon="el-icon-circle-check"
      confirm-type="primary"
      cancel-text="Hủy"
      @confirm="handleConfirmLink"
      @cancel="dialogLinkVisible = false"
      @update:visible="dialogLinkVisible = $event"
    >
      <div class="dialog-link-wrapper">
        <el-form label-position="top" size="small" @submit.native.prevent="handleConfirmLink">
          <el-form-item label="Đường dẫn (URL)">
            <el-input
              v-model="linkForm.url"
              placeholder="https://example.com"
              prefix-icon="el-icon-link"
              clearable
            ></el-input>
          </el-form-item>

          <el-form-item label="Văn bản hiển thị">
            <el-input
              v-model="linkForm.text"
              placeholder="Nhập chữ hiển thị (để trống nếu dùng chữ đã bôi đen)"
              prefix-icon="el-icon-edit-outline"
              clearable
            ></el-input>
          </el-form-item>

          <div class="link-option-row">
            <el-checkbox v-model="linkForm.openInNewTab">
              <i class="el-icon-open" /> Mở trong thẻ mới
            </el-checkbox>
          </div>
        </el-form>
      </div>
      <template #footer v-if="linkForm.isEditing">
        <div class="dialog-footer-custom">
          <el-button size="small" type="danger" plain icon="el-icon-delete" @click="handleRemoveLink">Xóa liên kết</el-button>
          <div style="flex: 1;"></div>
          <el-button size="small" type="danger" @click="dialogLinkVisible = false">Hủy</el-button>
          <el-button size="small" type="success" icon="el-icon-circle-check" @click="handleConfirmLink">Lưu liên kết</el-button>
        </div>
      </template>
    </DialogBase>

    <!-- Dialog Chèn Hình Ảnh hiện đại -->
    <DialogBase
      :visible="dialogImageVisible"
      :append-to-body="true"
      title="Chèn hình ảnh"
      width="540px"
      top="12vh"
      panel-icon="el-icon-picture-outline"
      panel-title="Chèn hình ảnh vào nội dung"
      panel-subtitle="Tải ảnh từ máy tính hoặc chèn trực tiếp từ đường dẫn URL"
      :show-footer="false"
      @cancel="dialogImageVisible = false"
      @update:visible="dialogImageVisible = $event"
    >
      <div class="dialog-image-wrapper">
        <el-tabs v-model="imageTabActive" type="card" class="image-dialog-tabs">
          <!-- Tab 1: Upload File từ máy tính -->
          <el-tab-pane label="Tải ảnh từ máy tính" name="upload">
            <div class="upload-tab-content">
              <el-upload
                class="image-drag-uploader"
                drag
                action=""
                :auto-upload="false"
                accept="image/*"
                :on-change="handleImageFileSelect"
                :show-file-list="false"
              >
                <div v-if="!imageForm.previewUrl" class="upload-drag-inner">
                  <i class="el-icon-upload" />
                  <div class="el-upload__text">Kéo thả hình ảnh vào đây hoặc <em>nhấp để chọn tệp</em></div>
                  <div class="el-upload__tip">Hỗ trợ định dạng JPG, PNG, GIF, WEBP (Tối đa 5MB)</div>
                </div>
                <div v-else class="upload-preview-inner">
                  <img :src="imageForm.previewUrl" class="preview-img-thumbnail" alt="Xem trước ảnh" />
                  <div class="preview-img-info">
                    <span class="img-filename">{{ imageForm.file ? imageForm.file.name : 'Hình ảnh đã chọn' }}</span>
                    <el-button type="text" icon="el-icon-refresh" @click.stop="imageForm.previewUrl = ''; imageForm.file = null;">Chọn ảnh khác</el-button>
                  </div>
                </div>
              </el-upload>

              <div class="dialog-action-row">
                <el-button size="small" type="danger" @click="dialogImageVisible = false">Hủy</el-button>
                <el-button
                  size="small"
                  type="success"
                  icon="el-icon-circle-check"
                  :loading="loadingButton.addImage"
                  :disabled="!imageForm.file"
                  @click="handleConfirmImageUpload"
                >
                  Tải lên & Chèn ảnh
                </el-button>
              </div>
            </div>
          </el-tab-pane>

          <!-- Tab 2: Chèn bằng Đường dẫn URL -->
          <el-tab-pane label="Chèn từ URL hình ảnh" name="url">
            <div class="url-tab-content">
              <el-form label-position="top" size="small" @submit.native.prevent="handleConfirmImageUrl">
                <el-form-item label="Đường dẫn ảnh (URL)">
                  <el-input
                    v-model="imageForm.url"
                    placeholder="https://example.com/hinh-anh.jpg"
                    prefix-icon="el-icon-link"
                    clearable
                  ></el-input>
                </el-form-item>

                <!-- Dynamic Preview -->
                <div v-if="imageForm.url" class="url-img-preview-box">
                  <span class="preview-label">Xem trước hình ảnh:</span>
                  <div class="preview-img-card">
                    <img :src="imageForm.url" alt="Preview" @error="handleImagePreviewError" />
                  </div>
                </div>
              </el-form>

              <div class="dialog-action-row" style="margin-top: 20px;">
                <el-button size="small" type="danger" @click="dialogImageVisible = false">Hủy</el-button>
                <el-button
                  size="small"
                  type="success"
                  icon="el-icon-circle-check"
                  :disabled="!imageForm.url"
                  @click="handleConfirmImageUrl"
                >
                  Chèn hình ảnh
                </el-button>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </DialogBase>
  </div>
</template>

<script>
import {Editor, EditorContent} from '@tiptap/vue-2'
import DialogBase from "@/components/DialogBase.vue";
import StarterKit from '@tiptap/starter-kit'
import {Link} from "@tiptap/extension-link";
import {TextAlign} from "@tiptap/extension-text-align";
import {FontFamily} from "@tiptap/extension-font-family";
import {TextStyle} from "@tiptap/extension-text-style";
import {Typography} from "@tiptap/extension-typography";
import {Underline} from "@tiptap/extension-underline";
import {Color} from "@tiptap/extension-color";
import {colorText} from "@/constant/listCommon";
import {Highlight} from "@tiptap/extension-highlight";
import {Superscript} from "@tiptap/extension-superscript";
import {Subscript} from "@tiptap/extension-subscript";
import {ImageUpload} from "@/utils/tiptap/ImageUpload";
import icon from "../../assets/icons";
import TextEditorService from "@/services/TextEditorService";
import { Extension } from '@tiptap/core';
import Table from '@tiptap/extension-table';
import TableRow from '@tiptap/extension-table-row';
import TableCell from '@tiptap/extension-table-cell';
import TableHeader from '@tiptap/extension-table-header';
import { Decoration, DecorationSet } from "prosemirror-view";
import { Plugin, PluginKey } from "prosemirror-state";

const FontSize = Extension.create({
  name: 'fontSize',
  addOptions() {
    return {
      types: ['textStyle'],
    };
  },
  addGlobalAttributes() {
    return [
      {
        types: this.options.types,
        attributes: {
          fontSize: {
            default: null,
            parseHTML: element => element.style.fontSize,
            renderHTML: attributes => {
              if (!attributes.fontSize) {
                return {};
              }
              return {
                style: `font-size: ${attributes.fontSize}`,
              };
            },
          },
        },
      },
    ];
  },
  addCommands() {
    return {
      setFontSize: fontSize => ({ chain }) => {
        return chain()
          .setMark('textStyle', { fontSize })
          .run();
      },
      unsetFontSize: () => ({ chain }) => {
        return chain()
          .setMark('textStyle', { fontSize: null })
          .run();
      },
    };
  },
});

const LineHeight = Extension.create({
  name: 'lineHeight',
  addOptions() {
    return {
      types: ['paragraph', 'heading'],
      defaultLineHeight: 'normal',
    };
  },
  addGlobalAttributes() {
    return [
      {
        types: this.options.types,
        attributes: {
          lineHeight: {
            default: this.options.defaultLineHeight,
            parseHTML: element => element.style.lineHeight || this.options.defaultLineHeight,
            renderHTML: attributes => {
              if (attributes.lineHeight === this.options.defaultLineHeight) {
                return {};
              }
              return {
                style: `line-height: ${attributes.lineHeight}`,
              };
            },
          },
        },
      },
    ];
  },
  addCommands() {
    return {
      setLineHeight:
        lineHeight =>
        ({ commands }) => {
          return this.options.types.every(type =>
            commands.updateAttributes(type, { lineHeight })
          );
        },
      unsetLineHeight:
        () =>
        ({ commands }) => {
          return this.options.types.every(type =>
            commands.updateAttributes(type, { lineHeight: this.options.defaultLineHeight })
          );
        },
    };
  },
});

const SearchAndReplace = Extension.create({
  name: 'searchAndReplace',

  addOptions() {
    return {
      searchResultClass: 'search-result',
    };
  },

  addStorage() {
    return {
      searchTerm: '',
      replaceTerm: '',
      results: [],
      currentIndex: 0,
    };
  },

  addProseMirrorPlugins() {
    const extension = this;
    return [
      new Plugin({
        key: new PluginKey('searchAndReplace'),
        state: {
          init() {
            return DecorationSet.empty;
          },
          apply(tr, oldVal, oldState, newState) {
            const searchTerm = extension.storage.searchTerm;
            if (!searchTerm) {
              extension.storage.results = [];
              extension.storage.currentIndex = 0;
              return DecorationSet.empty;
            }

            const decorations = [];
            const results = [];
            
            newState.doc.descendants((node, pos) => {
              if (node.isText) {
                const nodeText = node.text;
                let startIdx = 0;
                let matchIdx = nodeText.toLowerCase().indexOf(searchTerm.toLowerCase(), startIdx);
                while (matchIdx !== -1) {
                  results.push({
                    from: pos + matchIdx,
                    to: pos + matchIdx + searchTerm.length,
                  });
                  startIdx = matchIdx + searchTerm.length;
                  matchIdx = nodeText.toLowerCase().indexOf(searchTerm.toLowerCase(), startIdx);
                }
              }
            });

            extension.storage.results = results;
            if (extension.storage.currentIndex >= results.length) {
              extension.storage.currentIndex = 0;
            }

            results.forEach((r, idx) => {
              const isActive = idx === extension.storage.currentIndex;
              decorations.push(
                Decoration.inline(r.from, r.to, {
                  class: isActive ? 'search-result-current' : extension.options.searchResultClass,
                })
              );
            });

            return DecorationSet.create(newState.doc, decorations);
          },
        },
        props: {
          decorations(state) {
            return this.getState(state);
          },
        },
      }),
    ];
  },

  addCommands() {
    return {
      setSearchTerm:
        searchTerm =>
        ({ editor }) => {
          this.storage.searchTerm = searchTerm;
          editor.view.dispatch(editor.view.state.tr);
          return true;
        },
      setReplaceTerm:
        replaceTerm =>
        () => {
          this.storage.replaceTerm = replaceTerm;
          return true;
        },
      goToNext:
        () =>
        ({ editor }) => {
          const { results } = this.storage;
          if (results.length === 0) return false;
          this.storage.currentIndex = (this.storage.currentIndex + 1) % results.length;
          editor.view.dispatch(editor.view.state.tr);
          return true;
        },
      goToPrev:
        () =>
        ({ editor }) => {
          const { results } = this.storage;
          if (results.length === 0) return false;
          this.storage.currentIndex = (this.storage.currentIndex - 1 + results.length) % results.length;
          editor.view.dispatch(editor.view.state.tr);
          return true;
        },
      replace:
        () =>
        ({ editor }) => {
          const { searchTerm, replaceTerm, results, currentIndex } = this.storage;
          if (!searchTerm || results.length === 0) return false;

          const currentMatch = results[currentIndex];
          if (!currentMatch) return false;

          const { tr } = editor.view.state;
          tr.replaceWith(
            currentMatch.from,
            currentMatch.to,
            editor.schema.text(replaceTerm)
          );

          editor.view.dispatch(tr);
          return true;
        },
      replaceAll:
        () =>
        ({ editor }) => {
          const { searchTerm, replaceTerm } = this.storage;
          if (!searchTerm) return false;

          const { tr } = editor.view.state;
          let offset = 0;

          editor.view.state.doc.descendants((node, pos) => {
            if (node.isText) {
              const nodeText = node.text;
              let startIdx = 0;
              let matchIdx = nodeText.toLowerCase().indexOf(searchTerm.toLowerCase(), startIdx);
              while (matchIdx !== -1) {
                const from = pos + matchIdx + offset;
                const to = from + searchTerm.length;
                tr.replaceWith(from, to, editor.schema.text(replaceTerm));
                offset += replaceTerm.length - searchTerm.length;
                startIdx = matchIdx + searchTerm.length;
                matchIdx = nodeText.toLowerCase().indexOf(searchTerm.toLowerCase(), startIdx);
              }
            }
          });

          editor.view.dispatch(tr);
          return true;
        },
    };
  },
});

export function ensureInlineTableStyles(html) {
  if (!html || typeof html !== 'string' || !html.includes('<table')) return html;
  try {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');
    const tables = doc.querySelectorAll('table');

    if (tables.length === 0) return html;

    tables.forEach(table => {
      table.setAttribute('border', '1');
      const tableStyle = table.getAttribute('style') || '';
      if (!tableStyle.includes('border-collapse')) {
        table.setAttribute('style', `border-collapse: collapse; width: 100%; border: 1px solid #ced4da; ${tableStyle}`.trim());
      }

      table.querySelectorAll('td, th').forEach(cell => {
        const cellStyle = cell.getAttribute('style') || '';
        const alignAttr = cell.getAttribute('align');
        const valignAttr = cell.getAttribute('valign');
        const bgAttr = cell.getAttribute('bgcolor');
        const isHeader = cell.tagName.toLowerCase() === 'th';

        let extraStyles = [];
        if (alignAttr && !cellStyle.includes('text-align')) {
          extraStyles.push(`text-align: ${alignAttr}`);
        }
        if (valignAttr && !cellStyle.includes('vertical-align')) {
          extraStyles.push(`vertical-align: ${valignAttr}`);
        }
        if (bgAttr && !cellStyle.includes('background-color')) {
          extraStyles.push(`background-color: ${bgAttr}`);
        }

        const baseStyle = isHeader
          ? 'border: 1px solid #ced4da; padding: 6px 8px; background-color: #f8fafc; font-weight: bold;'
          : 'border: 1px solid #ced4da; padding: 6px 8px;';

        let newStyle = cellStyle;
        if (!cellStyle.includes('border')) {
          newStyle = `${baseStyle} ${newStyle}`;
        }
        if (extraStyles.length > 0) {
          newStyle = `${newStyle}; ${extraStyles.join('; ')}`;
        }

        cell.setAttribute('style', newStyle.trim());
      });
    });

    return doc.body.innerHTML;
  } catch (e) {
    return html;
  }
}

const CustomTable = Table.extend({
  renderHTML({ HTMLAttributes }) {
    const defaultStyle = 'border-collapse: collapse; width: 100%; border: 1px solid #ced4da;';
    const existingStyle = HTMLAttributes.style ? `; ${HTMLAttributes.style}` : '';
    return [
      'table',
      {
        ...HTMLAttributes,
        border: '1',
        style: `${defaultStyle}${existingStyle}`,
      },
      0,
    ];
  },
});

const CustomTableCell = TableCell.extend({
  addAttributes() {
    return {
      ...this.parent?.(),
      backgroundColor: {
        default: null,
        parseHTML: element => element.getAttribute('data-background-color') || element.getAttribute('bgcolor') || element.style.backgroundColor,
        renderHTML: attributes => {
          if (!attributes.backgroundColor || attributes.backgroundColor === 'transparent') {
            return {};
          }
          return {
            'data-background-color': attributes.backgroundColor,
            style: `background-color: ${attributes.backgroundColor}`,
          };
        },
      },
      textAlign: {
        default: null,
        parseHTML: element => element.getAttribute('align') || element.style.textAlign,
        renderHTML: attributes => {
          if (!attributes.textAlign) {
            return {};
          }
          return {
            style: `text-align: ${attributes.textAlign}`,
          };
        },
      },
      verticalAlign: {
        default: null,
        parseHTML: element => element.getAttribute('valign') || element.style.verticalAlign,
        renderHTML: attributes => {
          if (!attributes.verticalAlign) {
            return {};
          }
          return {
            style: `vertical-align: ${attributes.verticalAlign}`,
          };
        },
      },
    };
  },
  renderHTML({ HTMLAttributes }) {
    const defaultStyle = 'border: 1px solid #ced4da; padding: 6px 8px; vertical-align: top;';
    const existingStyle = HTMLAttributes.style ? `${HTMLAttributes.style}` : '';
    const mergedStyle = existingStyle.includes('border:')
      ? existingStyle
      : `${defaultStyle} ${existingStyle}`;
    return [
      'td',
      {
        ...HTMLAttributes,
        style: mergedStyle.trim(),
      },
      0,
    ];
  },
});

const CustomTableHeader = TableHeader.extend({
  addAttributes() {
    return {
      ...this.parent?.(),
      backgroundColor: {
        default: null,
        parseHTML: element => element.getAttribute('data-background-color') || element.getAttribute('bgcolor') || element.style.backgroundColor,
        renderHTML: attributes => {
          if (!attributes.backgroundColor || attributes.backgroundColor === 'transparent') {
            return {};
          }
          return {
            'data-background-color': attributes.backgroundColor,
            style: `background-color: ${attributes.backgroundColor}`,
          };
        },
      },
      textAlign: {
        default: null,
        parseHTML: element => element.getAttribute('align') || element.style.textAlign,
        renderHTML: attributes => {
          if (!attributes.textAlign) {
            return {};
          }
          return {
            style: `text-align: ${attributes.textAlign}`,
          };
        },
      },
      verticalAlign: {
        default: null,
        parseHTML: element => element.getAttribute('valign') || element.style.verticalAlign,
        renderHTML: attributes => {
          if (!attributes.verticalAlign) {
            return {};
          }
          return {
            style: `vertical-align: ${attributes.verticalAlign}`,
          };
        },
      },
    };
  },
  renderHTML({ HTMLAttributes }) {
    const defaultStyle = 'border: 1px solid #ced4da; padding: 6px 8px; background-color: #f8fafc; font-weight: bold; vertical-align: top;';
    const existingStyle = HTMLAttributes.style ? `${HTMLAttributes.style}` : '';
    const mergedStyle = existingStyle.includes('border:')
      ? existingStyle
      : `${defaultStyle} ${existingStyle}`;
    return [
      'th',
      {
        ...HTMLAttributes,
        style: mergedStyle.trim(),
      },
      0,
    ];
  },
});

export default {
  components: {
    EditorContent,
    DialogBase
  },
  props: {
    value: {
      type: String,
      default: "",
    },
    height: {
      type: String,
      default: "300px",
    },
    editorService: {
      type: Object,
      default: () => TextEditorService
    }
  },
  data() {
    return {
      flag: true,
      linkURL: "",
      dialogLinkVisible: false,
      dialogImageVisible: false,
      linkForm: {
        url: '',
        text: '',
        openInNewTab: true,
        isEditing: false,
      },
      imageTabActive: 'upload',
      imageForm: {
        url: '',
        file: null,
        previewUrl: '',
      },
      editor: null,
      isFullscreen: false,
      selectedLineHeight: 'normal',
      showSearchReplace: false,
      searchQuery: "",
      replaceQuery: "",
      controlHeading: {
        countOption: 3,
        selectedHeading: null,
      },
      controlFontFamily: {
        selectedFontFamily: 'unset',
        optionsFontFamily: [
          { value: "unset", label: "Mặc định" },
          { value: "Arial, sans-serif", label: "Arial" },
          { value: "Times New Roman, Times, serif", label: "Times New Roman" },
          { value: "Helvetica, Arial, sans-serif", label: "Helvetica" },
          { value: "Tahoma, Geneva, sans-serif", label: "Tahoma" },
          { value: "Verdana, Geneva, sans-serif", label: "Verdana" },
          { value: "Georgia, serif", label: "Georgia" },
          { value: "Courier New, Courier, monospace", label: "Courier New" },
          { value: "Comic Sans MS, Comic Sans", label: "Comic Sans" },
          { value: "Impact, Charcoal, sans-serif", label: "Impact" },
          { value: "Trebuchet MS, Helvetica, sans-serif", label: "Trebuchet MS" },
          { value: "Garamond, serif", label: "Garamond" },
          { value: "Inter, sans-serif", label: "Inter" }
        ]
      },
      optionsTextAlign: [
        {
          value: 'left',
          icon: icon.justify_left
        },
        {
          value: "right",
          icon: icon.justify_right
        },
        {
          value: "center",
          icon: icon.justify_center
        },
        {
          value: "justify",
          icon: icon.justify
        }
      ],
      selectedFontSize: '14px',
      tableCellColors: [
        { value: 'transparent', label: 'Không màu' },
        { value: '#f8fafc', label: 'Xám nhạt' },
        { value: '#fee2e2', label: 'Đỏ nhạt' },
        { value: '#fef9c3', label: 'Vàng nhạt' },
        { value: '#dcfce7', label: 'Xanh lá nhạt' },
        { value: '#dbeafe', label: 'Xanh dương nhạt' },
        { value: '#f3e8ff', label: 'Tím nhạt' },
        { value: '#ffedd5', label: 'Cam nhạt' },
        { value: '#e2e8f0', label: 'Xám header' },
        { value: '#cbd5e1', label: 'Xám đậm' }
      ],
      fontSizes: ['12px', '13px', '14px', '15px', '16px', '18px', '20px', '24px', '28px', '32px', '36px'],
      gridHover: {
        rows: 0,
        cols: 0
      },
      color: {
        text: '#000',
        background: 'transparent',
      },
      popoverControl: {
        color: false,
        background: false,
        link: false,
        image: false,
        emoji: false,
        table: false,
        specialChar: false,
      },
      commonEmojis: [
        '😀', '😃', '😄', '😁', '😆', '😅', '😂', '🤣', '😊', '😇',
        '🙂', '🙃', '😉', '😌', '😍', '🥰', '😘', '😗', '😙', '😚',
        '😋', '😛', '😝', '😜', '🤪', '🤨', '🧐', '🤓', '😎', '🤩',
        '🥳', '😏', '😒', '😞', '😔', '😟', '😕', '🙁', '☹️', '😣',
        '😖', '😫', '😩', '🥺', '😢', '😭', '😤', '😠', '😡', '🤬',
        '🤯', '😳', '🥵', '🥶', '😱', '😨', '😰', '😥', '😓', '🤗',
        '🤔', '🤭', '🤫', '🤥', '😶', '😐', '😑', '😬', '🙄', '😯',
        '😦', '😧', '😮', '😲', '🥱', '😴', '🤤', '😪', '😵', '🤐',
        '🥴', '🤢', '🤮', '🤧', '😷', '🤒', '🤕', '🤑', '🤠', '😈',
        '👿', '👹', '👺', '🤡', '💩', '👻', '💀', '☠️', '👽', '👾',
        '🤖', '🎃', '😺', '😸', '😹', '😻', '😼', '😽', '🙀', '😿',
        '😾', '👋', '🤚', '🖐️', '✋', '🖖', '👌', '✌️', '🤞',
        '🤟', '🤘', '🤙', '👈', '👉', '👆', '🖕', '👇', '☝️', '👍',
        '👎', '✊', '👊', '🤛', '🤜', '👏', '🙌', '👐', '🤲', '🤝',
        '🙏', '✍️', '💅', '🤳', '💪', '🦾', '🦿', '🦵', '🦶', '👂',
        '🦻', '👃', '🧠', '🦷', '🦴', '👀', '👁️', '👅', '👄', '💋',
        '🩸', '❤️', '🧡', '💛', '💚', '💙', '💜', '🖤', '🤍', '🤎',
        '💔', '❣️', '💕', '💞', '💓', '💗', '💖', '💘', '💝', '💟',
        '🌟', '⭐', '✨', '⚡', '💥', '🔥', '🌈', '☀️'
      ],
      specialChars: [
        '½', '¼', '¾', '±', '×', '÷', '°', 'µ', 'π', 'Ω', '€', '£', '¥', '©', '®', '™', '§', '†', '‡', '•',
        '–', '—', '«', '»', '“', '”', '‘', '’', '…', '∞', '√', '≈', '≠', '≤', '≥', '→', '←', '↑', '↓', '↔',
        '♠', '♣', '♥', '♦', 'α', 'β', 'γ', 'δ', 'θ', 'λ', 'μ', 'σ', 'φ', 'ψ', 'ω'
      ],
      imageAddPost: [],
      loadingButton: {
        addImage: false,
      },
      imagePost: {
        max: 5,
        listImageInitial: [],
        listImageDelete: [],
      }
    };
  },

  watch: {
    value(value) {
      const isSame = this.editor.getHTML() === value

      if (value && this.flag) {
        this.extractImageInfo(value);
        this.flag = false;
      }

      if (isSame) {
        return
      }

      this.editor.commands.setContent(value, false)
    },

    "controlFontFamily.selectedFontFamily"(value) {
      if (value && value !== 'unset') {
        this.editor.chain().focus().setFontFamily(value).run()
      } else {
        this.editor.chain().focus().clearMark('fontFamily').run();
      }
    }
  },
  computed: {
    icon() {
      return icon
    },

    internalValue: {
      get() {
        return this.value; // Lấy giá trị từ prop
      },

      set(newValue) {
        this.$emit("input", newValue); // Phát sự kiện để cập nhật component cha
      },
    },

    wordCount() {
      if (!this.editor) return 0;
      const text = this.editor.getText().trim();
      return text ? text.split(/\s+/).length : 0;
    },

    charCount() {
      if (!this.editor) return 0;
      return this.editor.getText().length;
    },

    searchStats() {
      if (!this.editor || !this.editor.storage.searchAndReplace) {
        return { current: 0, total: 0 };
      }
      const storage = this.editor.storage.searchAndReplace;
      return {
        current: storage.results.length > 0 ? storage.currentIndex + 1 : 0,
        total: storage.results.length,
      };
    }
  },
  mounted() {
    this.editor = new Editor({
      editorProps: {
        transformPastedHTML(html) {
          if (!html || typeof html !== 'string') return html;
          try {
            let cleaned = html
              .replace(/<!--[\s\S]*?-->/gi, '')
              .replace(/<o:p>[\s\S]*?<\/o:p>/gi, '');

            const parser = new DOMParser();
            const doc = parser.parseFromString(cleaned, 'text/html');

            doc.querySelectorAll('[align]').forEach(el => {
              const alignVal = el.getAttribute('align');
              if (alignVal) {
                const style = el.getAttribute('style') || '';
                if (!style.includes('text-align')) {
                  el.setAttribute('style', `text-align: ${alignVal}; ${style}`.trim());
                }
              }
            });

            doc.querySelectorAll('[valign]').forEach(el => {
              const valignVal = el.getAttribute('valign');
              if (valignVal) {
                const style = el.getAttribute('style') || '';
                if (!style.includes('vertical-align')) {
                  el.setAttribute('style', `vertical-align: ${valignVal}; ${style}`.trim());
                }
              }
            });

            doc.querySelectorAll('[bgcolor]').forEach(el => {
              const bgVal = el.getAttribute('bgcolor');
              if (bgVal) {
                const style = el.getAttribute('style') || '';
                if (!style.includes('background-color')) {
                  el.setAttribute('style', `background-color: ${bgVal}; ${style}`.trim());
                }
              }
            });

            doc.querySelectorAll('table').forEach(table => {
              table.setAttribute('border', '1');
              const tableStyle = table.getAttribute('style') || '';
              if (!tableStyle.includes('border-collapse')) {
                table.setAttribute('style', `border-collapse: collapse; width: 100%; border: 1px solid #ced4da; ${tableStyle}`.trim());
              }

              table.querySelectorAll('td, th').forEach(cell => {
                const cellStyle = cell.getAttribute('style') || '';
                const isHeader = cell.tagName.toLowerCase() === 'th';
                const defaultStyle = isHeader
                  ? 'border: 1px solid #ced4da; padding: 6px 8px; background-color: #f8fafc; font-weight: bold;'
                  : 'border: 1px solid #ced4da; padding: 6px 8px;';

                if (!cellStyle.includes('border')) {
                  cell.setAttribute('style', `${defaultStyle} ${cellStyle}`.trim());
                }
              });
            });

            return doc.body.innerHTML;
          } catch (e) {
            return html;
          }
        },
      },
      content: this.value,
      injectCSS: false,
      extensions: [
        StarterKit,
        Underline,
        Link.configure({
          openOnClick: false,
          linkOnPaste: true,
          autolink: true,
        }),
        TextAlign.configure({
          types: ['heading', 'paragraph'],
        }),
        Color.configure({
          types: ['textStyle'],
        }),
        Highlight.configure({
          multicolor: true
        }),
        TextStyle,
        FontFamily,
        FontSize,
        Typography,
        Superscript,
        Subscript,
        ImageUpload,
        CustomTable.configure({
          resizable: true,
        }),
        TableRow,
        CustomTableHeader,
        CustomTableCell,
        LineHeight,
        SearchAndReplace,
      ],
      onUpdate: () => {
        const rawHTML = this.editor.getHTML();
        const formattedHTML = ensureInlineTableStyles(rawHTML);
        this.$emit('input', formattedHTML);
        this.updateSelectedHeading();
      },

      onTransaction: ({transaction}) => {
        const oldDoc = transaction.before;
        const newDoc = transaction.doc;

        const deletedImages = [];

        oldDoc.descendants((node, pos) => {
          if (node.type.name === 'image') {
            // Kiểm tra xem node này có còn tồn tại trong newDoc không
            const newNode = newDoc.nodeAt(pos);
            if (!newNode || newNode.type.name !== 'image') {
              deletedImages.push(node.attrs.id);
            }
          }
        });

        if (deletedImages.length > 0) {
          this.pushIdImageDelete(deletedImages);
        }
      },

      onSelectionUpdate: () => {
        this.updateSelectedHeading();
        this.getCurrentTextColor();
        this.getCurrentHighLight();
        this.getCurrentLink();
        this.getCurrentFontSize();
        this.getCurrentLineHeight();
      },
    })
  },
  methods: {
    toggleFullscreen() {
      this.isFullscreen = !this.isFullscreen;
    },

    updateLineHeight(height) {
      if (height === 'normal') {
        this.editor.chain().focus().unsetLineHeight().run();
      } else {
        this.editor.chain().focus().setLineHeight(height).run();
      }
    },

    getCurrentLineHeight() {
      const isParagraph = this.editor.isActive('paragraph');
      const isHeading = this.editor.isActive('heading');
      if (isParagraph) {
        const attrs = this.editor.getAttributes('paragraph');
        this.selectedLineHeight = attrs.lineHeight || 'normal';
      } else if (isHeading) {
        const attrs = this.editor.getAttributes('heading');
        this.selectedLineHeight = attrs.lineHeight || 'normal';
      } else {
        this.selectedLineHeight = 'normal';
      }
    },

    insertSpecialChar(char) {
      this.editor.chain().focus().insertContent(char).run();
      this.popoverControl.specialChar = false;
    },

    toggleSearchReplace() {
      this.showSearchReplace = !this.showSearchReplace;
      if (!this.showSearchReplace) {
        this.closeSearchReplace();
      }
    },

    onSearchInput() {
      this.editor.commands.setSearchTerm(this.searchQuery);
    },

    handleReplace() {
      this.editor.commands.setReplaceTerm(this.replaceQuery);
      this.editor.commands.replace();
    },

    handleReplaceAll() {
      this.editor.commands.setReplaceTerm(this.replaceQuery);
      this.editor.commands.replaceAll();
    },

    closeSearchReplace() {
      this.searchQuery = "";
      this.replaceQuery = "";
      this.editor.commands.setSearchTerm("");
      this.showSearchReplace = false;
    },

    handlePrevMatch() {
      this.editor.commands.goToPrev();
    },

    handleNextMatch() {
      this.editor.commands.goToNext();
    },

    reset() {
      this.controlFontFamily.selectedFontFamily = "unset";
      this.selectedFontSize = "14px";
      this.resetImagePost();
      this.flag = true;
    },

    updateFontSize(size) {
      if (size && size !== '14px') {
        this.editor.chain().focus().setFontSize(size).run();
      } else {
        this.editor.chain().focus().unsetFontSize().run();
      }
    },

    getCurrentFontSize() {
      const attrs = this.editor.getAttributes('textStyle');
      if (attrs && attrs.fontSize) {
        this.selectedFontSize = attrs.fontSize;
      } else {
        this.selectedFontSize = '14px';
      }
    },

    insertEmoji(emoji) {
      this.editor.chain().focus().insertContent(emoji).run();
      this.popoverControl.emoji = false;
    },

    onGridHover(r, c) {
      this.gridHover.rows = r;
      this.gridHover.cols = c;
    },

    resetGridHover() {
      this.gridHover.rows = 0;
      this.gridHover.cols = 0;
    },

    createTableFromGrid(r, c) {
      this.editor.chain().focus().insertTable({ rows: r, cols: c, withHeaderRow: true }).run();
      this.popoverControl.table = false;
      this.resetGridHover();
    },

    execTableCmd(cmdType) {
      if (cmdType === 'addColumnBefore') {
        this.editor.chain().focus().addColumnBefore().run();
      } else if (cmdType === 'addColumnAfter') {
        this.editor.chain().focus().addColumnAfter().run();
      } else if (cmdType === 'deleteColumn') {
        this.editor.chain().focus().deleteColumn().run();
      } else if (cmdType === 'addRowBefore') {
        this.editor.chain().focus().addRowBefore().run();
      } else if (cmdType === 'addRowAfter') {
        this.editor.chain().focus().addRowAfter().run();
      } else if (cmdType === 'deleteRow') {
        this.editor.chain().focus().deleteRow().run();
      } else if (cmdType === 'mergeOrSplit') {
        this.editor.chain().focus().mergeOrSplit().run();
      } else if (cmdType === 'deleteTable') {
        this.editor.chain().focus().deleteTable().run();
      }
      this.popoverControl.table = false;
    },

    setCellBgColor(color) {
      this.editor.chain().focus().setCellAttribute('backgroundColor', color === 'transparent' ? null : color).run();
      this.popoverControl.table = false;
    },

    resetImagePost() {
      this.imagePost.listImageInitial = [];
    },

    extractImageInfo(content) {
      const imgTagRegex = /<img[^>]+src="([^">]+)"[^>]*id="([^">]+)"/g;
      let match;

      while ((match = imgTagRegex.exec(content)) !== null) {
        this.imagePost.listImageInitial.push(parseInt(match[2]));
      }
    },

    pushIdImageDelete(ids) {
      this.imagePost.listImageDelete = [...ids];
    },

    handleAddImage(file, fileList) {
      this.imageAddPost = fileList;
    },

    handleSuccessImage() {
      const file = this.imageAddPost[0].raw;
      const formData = new FormData();

      formData.append('file', file)
      this.loadingButton.addImage = true;
      this.editorService.addImageInPost(formData)
          .then(res => {
            const data = res.data.data;
            this.editor.commands.setImage({src: data.url, id: data.id});
            this.popoverControl.image = false;
            this.imageAddPost = [];
          })
          .catch(err => {
            console.log(err);
          })
          .finally(() => {
            this.loadingButton.addImage = false;
          })
    },

    getCurrentTextColor() {
      const currentColorText = this.editor.getAttributes('textStyle').color;
      this.color.text = currentColorText || '#000';
    },

    getCurrentLink() {
      const currentLinkText = this.editor.getAttributes('link').href;
      this.linkURL = currentLinkText || '';
    },

    getCurrentHighLight() {
      const currentHighLight = this.editor.getAttributes("highlight");
      this.color.background = currentHighLight.color || 'transparent'
    },

    colorText() {
      return colorText
    },

    addColorText(color) {
      this.editor.chain().focus().setColor(color).run()
      this.color.text = color;
    },

    addColorBackground(item) {
      this.color.background = item ? item : "transparent";
      if (item) {
        this.editor.chain().focus().toggleHighlight({color: item}).run()
      } else {
        this.editor.chain().focus().unsetHighlight().run();
      }
    },

    updateSelectedHeading() {
      const currentHeading = this.editor.getAttributes('heading').level;
      this.controlHeading.selectedHeading = currentHeading || null; // Nếu không có heading, đặt là null
    },

    updateHeading() {
      if (this.controlHeading.selectedHeading) {
        this.editor.chain().focus().setHeading({level: this.controlHeading.selectedHeading}).run();
      } else {
        this.editor.chain().focus().clearNodes('heading').run()
      }
    },

    openLinkDialog() {
      const { from, to } = this.editor.state.selection;
      const selectedText = this.editor.state.doc.textBetween(from, to, ' ');
      const linkAttrs = this.editor.getAttributes('link');
      const isEditing = !!linkAttrs.href;

      this.linkForm = {
        url: linkAttrs.href || '',
        text: selectedText || '',
        openInNewTab: isEditing ? (linkAttrs.target !== '_self') : true,
        isEditing: isEditing,
      };
      this.dialogLinkVisible = true;
    },

    handleConfirmLink() {
      let url = this.linkForm.url ? this.linkForm.url.trim() : '';

      if (!url) {
        this.editor.chain().focus().extendMarkRange('link').unsetLink().run();
        this.dialogLinkVisible = false;
        return;
      }

      if (!/^https?:\/\//i.test(url) && !/^mailto:/i.test(url) && !/^\//.test(url) && !/^tel:/i.test(url)) {
        url = `https://${url}`;
      }

      const target = this.linkForm.openInNewTab ? '_blank' : null;
      const text = this.linkForm.text ? this.linkForm.text.trim() : '';
      const { from, to } = this.editor.state.selection;

      if (text && (from === to || this.editor.state.doc.textBetween(from, to, ' ') !== text)) {
        const targetAttr = target ? ` target="${target}"` : '';
        const linkHtml = `<a href="${url}"${targetAttr}>${text}</a>`;
        this.editor.chain().focus().insertContent(linkHtml).run();
      } else {
        this.editor
          .chain()
          .focus()
          .extendMarkRange('link')
          .setLink({ href: url, target: target })
          .run();
      }

      this.dialogLinkVisible = false;
      this.$message.success('Đã chèn liên kết thành công!');
    },

    handleRemoveLink() {
      this.editor.chain().focus().extendMarkRange('link').unsetLink().run();
      this.dialogLinkVisible = false;
      this.$message.success('Đã xóa liên kết!');
    },

    openImageDialog() {
      this.imageForm = {
        url: '',
        file: null,
        previewUrl: '',
      };
      this.imageTabActive = 'upload';
      this.dialogImageVisible = true;
    },

    handleImageFileSelect(file) {
      if (!file || !file.raw) return;
      const isImg = file.raw.type.startsWith('image/');
      const isLt5M = file.size / 1024 / 1024 < 5;

      if (!isImg) {
        this.$message.error('Tệp phải là hình ảnh (JPG, PNG, GIF, WEBP...)');
        return;
      }
      if (!isLt5M) {
        this.$message.error('Kích thước ảnh không thể vượt quá 5MB');
        return;
      }

      this.imageForm.file = file.raw;
      const reader = new FileReader();
      reader.onload = (e) => {
        this.imageForm.previewUrl = e.target.result;
      };
      reader.readAsDataURL(file.raw);
    },

    handleConfirmImageUpload() {
      if (!this.imageForm.file) {
        this.$message.warning('Vui lòng chọn hình ảnh để tải lên');
        return;
      }

      const formData = new FormData();
      formData.append('file', this.imageForm.file);
      this.loadingButton.addImage = true;

      this.editorService.addImageInPost(formData)
        .then(res => {
          const data = res.data.data;
          this.editor.commands.setImage({ src: data.url, id: data.id });
          this.dialogImageVisible = false;
          this.$message.success('Đã tải lên và chèn ảnh thành công!');
        })
        .catch(err => {
          console.error(err);
          this.$message.error('Tải ảnh lên thất bại, vui lòng thử lại');
        })
        .finally(() => {
          this.loadingButton.addImage = false;
        });
    },

    handleConfirmImageUrl() {
      let url = this.imageForm.url ? this.imageForm.url.trim() : '';
      if (!url) {
        this.$message.warning('Vui lòng nhập đường dẫn URL hình ảnh');
        return;
      }

      if (!/^https?:\/\//i.test(url) && !/^\//.test(url) && !/^data:image/i.test(url)) {
        url = `https://${url}`;
      }

      this.editor.commands.setImage({ src: url });
      this.dialogImageVisible = false;
      this.$message.success('Đã chèn hình ảnh thành công!');
    },

    handleImagePreviewError() {
      this.$message.error('Không thể tải hình ảnh từ URL này');
    },

    setLink(event) {
      if (event) event.preventDefault();
      this.openLinkDialog();
    },

    cancelLink() {
      this.dialogLinkVisible = false;
    },

    getImageNodes() {
      const imageNodes = [];
      this.editor.state.doc.descendants((node) => {
        if (node.type.name === 'image') {
          imageNodes.push(node.attrs.id);
        }
      });

      if (this.imagePost.listImageInitial.length > 0) {
        return imageNodes.filter(id => !this.imagePost.listImageInitial.includes(id));
      }

      return imageNodes;
    },

    handleRemoveMultiImage() {
      const idImages = this.getImageNodes();

      if (idImages.length > 0) {
        this.editorService.removeMultiImagePost(idImages)
            .catch((err) => {
              console.log(err)
            })
      }

      this.reset();
    },

    formatImageDelete(imageInPost) {
      return this.imagePost.listImageDelete.filter(id => !imageInPost.includes(id))
    },

    handleSetActiveImagePost() {
      const imageInPost = this.getImageNodes();
      const imageDelete = this.formatImageDelete(imageInPost);

      this.editorService.setDelActiveImage(imageDelete, imageInPost);
    }
  },
  beforeDestroy() {
    this.editor.destroy();
  },
};
</script>

<style lang="scss" scoped>
.container {
  border: 1px solid #ccc;
  border-radius: 10px;

  .content {
    padding: 0 16px;
  }

  .control-group {
    padding: 12px 0;
    border-bottom: 1px solid #ccc;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    row-gap: 8px;
  }
}

.button_group {
  display: flex;
  padding: 0 16px;
  height: 26px;
  align-items: center;

  & + & {
    border-left: 1px solid #ccc;
  }

  .is-active {
    background-color: #c4dcff;
    border-radius: 4px;
  }
}

.button_popover {
  border: none;
  padding: 0;
  font-size: 18px;
  color: #000;
}

.button_control {
  width: 18px;
  height: 18px;
  display: flex;
  justify-content: center;
  cursor: pointer;
  padding: 3px;

  & + & {
    margin-left: 10px;
  }

  & + .button_group-child {
    margin-left: 10px;
  }
}

.button_control-select {
  & + & {
    margin-left: 10px;
  }
}

.control_popover {
  line-height: normal;
}

.button_group-child {
  display: flex;
}

.content {
  overflow: auto;
  font-family: system-ui;
  line-height: initial;
  resize: vertical;

  /deep/ .ProseMirror:focus {
    outline: none;
  }

  /deep/ .ProseMirror {
    height: var(--editor-height, 400px);
  }
}

.style_text {
  flex-direction: column;
  align-items: center;
  gap: 1px;
}

.option_color {
  width: 100%;
  height: 100%;
}

.container_item {
  padding: 1px;
  width: 18px;
  height: 18px;
  cursor: pointer;
  margin-bottom: 6px;

  &:hover {
    background-color: #000;
  }
}

.is-active_color {
  background-color: #000;
}

/deep/ mark {
  background-color: #FAF594;
  border-radius: 0.4rem;
  box-decoration-break: clone;
  padding: 0.1rem 0.3rem;
}

.no-validate input {
  pointer-events: none;
}

.emoji-picker {
  display: grid;
  grid-template-columns: repeat(8, 1fr);
  gap: 6px;
  max-height: 200px;
  overflow-y: auto;
  padding: 4px;
}
.emoji-item {
  font-size: 20px;
  cursor: pointer;
  text-align: center;
  user-select: none;
  transition: transform 0.1s;
}
.emoji-item:hover {
  transform: scale(1.25);
}

/* Table styles in content area */
/deep/ table {
  border-collapse: collapse;
  table-layout: fixed;
  width: 100%;
  margin: 10px 0;
  overflow: hidden;

  td, th {
    min-width: 1em;
    border: 1px solid #ced4da;
    padding: 6px 8px;
    vertical-align: top;
    box-sizing: border-box;
    position: relative;

    > * {
      margin-bottom: 0;
    }
  }

  th {
    font-weight: bold;
    text-align: left;
    background-color: #f8fafc;
  }

  .selectedCell:after {
    z-index: 2;
    position: absolute;
    content: "";
    left: 0; right: 0; top: 0; bottom: 0;
    background: rgba(200, 200, 255, 0.3);
    pointer-events: none;
  }

  .column-resize-handle {
    position: absolute;
    right: -2px;
    top: 0;
    bottom: -2px;
    width: 4px;
    background-color: #adf;
    pointer-events: none;
  }
}

.table-menu {
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: 4px 0;
}
.table-menu-item {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  padding: 8px 12px;
  font-size: 13px;
  color: #334155;
  border-radius: 4px;
  user-select: none;
  transition: background-color 0.15s;

  i {
    font-size: 14px;
    width: 14px;
    text-align: center;
  }
}
.table-menu-item:hover {
  background-color: #f1f5f9;
}
.table-menu-divider {
  height: 1px;
  background-color: #e2e8f0;
  margin: 4px 0;
}
.table-insert-grid {
  padding: 8px;
}
.grid-container {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 6px;
  background-color: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  cursor: pointer;
}
.grid-row {
  display: flex;
  gap: 4px;
}
.grid-cell {
  width: 16px;
  height: 16px;
  border: 1px solid #cbd5e1;
  background-color: #fff;
  border-radius: 2px;
  transition: background-color 0.1s, border-color 0.1s;
}
.grid-cell.is-selected {
  background-color: #3b82f6;
  border-color: #2563eb;
}

.image-node-container {
  position: relative;
  display: block;
  max-width: 100%;
}
.image-toolbar {
  position: absolute;
  top: 8px;
  left: 50%;
  transform: translateX(-50%);
  background-color: rgba(15, 23, 42, 0.95);
  border: 1px solid rgba(255, 255, 255, 0.1);
  padding: 4px 6px;
  border-radius: 6px;
  display: flex;
  align-items: center;
  gap: 4px;
  z-index: 50;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -2px rgba(0, 0, 0, 0.1);
}
.image-toolbar-btn {
  background: transparent;
  border: none;
  color: #94a3b8;
  font-size: 11px;
  font-weight: 500;
  padding: 4px 8px;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.15s;
  line-height: 1;
}
.image-toolbar-btn:hover {
  background-color: rgba(255, 255, 255, 0.1);
  color: #f1f5f9;
}
.image-toolbar-btn.is-active {
  background-color: #3b82f6;
  color: #fff;
}
.image-toolbar-btn.delete-btn {
  color: #f87171;
}
.image-toolbar-btn.delete-btn:hover {
  background-color: #ef4444;
  color: #fff;
}
.image-toolbar-separator {
  width: 1px;
  height: 12px;
  background-color: rgba(255, 255, 255, 0.15);
  margin: 0 4px;
}

/* Fullscreen mode styling */
.container.is-fullscreen {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 9999;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  border-radius: 0;
  border: none;
  
  .control-group {
    padding: 12px 16px;
    border-bottom: 1px solid #e2e8f0;
  }
  
  .content {
    flex: 1;
    overflow-y: auto;
    padding: 20px 24px;
    background-color: #fff;
    
    /deep/ .ProseMirror {
      height: calc(100vh - 120px) !important;
    }
  }

  .editor-footer {
    border-radius: 0;
  }
}

/* Footer counter styling */
.editor-footer {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 8px 16px;
  background-color: #f8fafc;
  border-top: 1px solid #e2e8f0;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
  font-size: 12px;
  color: #64748b;
}
.footer-stat {
  font-size: 12px;
  color: #64748b;
  strong {
    color: #334155;
  }
}
.footer-stat-separator {
  margin: 0 8px;
  color: #cbd5e1;
}

.search-replace-panel {
  background-color: #f8fafc;
  padding: 8px 16px;
  border-bottom: 1px solid #e2e8f0;
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.search-replace-row {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
}
.special-char-picker {
  display: grid;
  grid-template-columns: repeat(8, 1fr);
  gap: 6px;
  max-height: 200px;
  overflow-y: auto;
  padding: 4px;
}
.special-char-item {
  font-size: 18px;
  cursor: pointer;
  text-align: center;
  user-select: none;
  transition: transform 0.1s;
}
.special-char-item:hover {
  transform: scale(1.25);
  background-color: #f1f5f9;
  border-radius: 4px;
}
/deep/ .search-result {
  background-color: #fef08a;
  border-bottom: 2px solid #eab308;
  border-radius: 2px;
}
/deep/ .search-result-current {
  background-color: #f97316 !important;
  color: #ffffff !important;
  border-bottom: 2px solid #ea580c !important;
  border-radius: 2px;
}

/* ─── Link & Image Dialog Styling ──────────────────── */
.dialog-link-wrapper {
  padding: 8px 4px;

  /deep/ .el-form-item {
    margin-bottom: 16px;
  }
  /deep/ .el-form-item__label {
    font-weight: 600;
    color: #334155;
    padding-bottom: 4px;
    font-size: 13px;
  }
  /deep/ .el-input__inner {
    border-radius: 8px;
    background: #f8fafc;
    border: 1px solid #e2e8f0;
    &:focus {
      border-color: #2563eb;
      background: #fff;
    }
  }
}

.link-option-row {
  margin-top: 10px;
  padding-top: 10px;
  border-top: 1px dashed #e2e8f0;

  /deep/ .el-checkbox__label {
    font-size: 13px;
    color: #475569;
  }
}

.dialog-footer-custom {
  display: flex;
  align-items: center;
  width: 100%;
}

.dialog-image-wrapper {
  padding: 4px;
}

.image-dialog-tabs {
  /deep/ .el-tabs__header {
    margin-bottom: 16px;
    border-bottom: 1px solid #e2e8f0;
  }
  /deep/ .el-tabs__item {
    font-weight: 600;
    color: #64748b;
    border-radius: 8px 8px 0 0;
    &.is-active {
      color: #2563eb;
      background-color: #eff6ff;
      border-color: #bfdbfe;
      border-bottom-color: transparent;
    }
  }
}

.image-drag-uploader {
  width: 100%;
  /deep/ .el-upload {
    width: 100%;
  }
  /deep/ .el-upload-dragger {
    width: 100%;
    height: 170px;
    border-radius: 12px;
    border: 2px dashed #cbd5e1;
    background: #f8fafc;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s ease;

    &:hover {
      border-color: #2563eb;
      background-color: #eff6ff;
    }
  }
}

.upload-drag-inner {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;

  .el-icon-upload {
    font-size: 42px;
    color: #3b82f6;
    margin: 0;
  }
  .el-upload__text {
    font-size: 13px;
    color: #475569;
    em {
      color: #2563eb;
      font-style: normal;
      font-weight: 600;
    }
  }
  .el-upload__tip {
    font-size: 12px;
    color: #94a3b8;
  }
}

.upload-preview-inner {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 12px;
}

.preview-img-thumbnail {
  width: 90px;
  height: 90px;
  object-fit: cover;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.preview-img-info {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 6px;

  .img-filename {
    font-weight: 600;
    font-size: 13px;
    color: #1e293b;
    word-break: break-all;
  }
}

.url-tab-content {
  padding: 4px 0;
}

.url-img-preview-box {
  margin-top: 12px;
  .preview-label {
    font-size: 12px;
    font-weight: 600;
    color: #64748b;
    margin-bottom: 6px;
    display: block;
  }
  .preview-img-card {
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    padding: 8px;
    background: #f8fafc;
    text-align: center;
    max-height: 180px;
    overflow: hidden;

    img {
      max-height: 160px;
      max-width: 100%;
      border-radius: 6px;
      object-fit: contain;
    }
  }
}

.dialog-action-row {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 16px;
  padding-top: 12px;
  border-top: 1px solid #f1f5f9;
}
</style>